"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tag = function Tag(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.3535 7.64644L12.3535 3.64644C12.2598 3.55267 12.1326 3.5 12 3.5C11.8674 3.5 11.7402 3.55267 11.6464 3.64644L7.64644 7.64644C7.60002 7.69287 7.56319 7.74798 7.53806 7.80865C7.51293 7.86931 7.5 7.93433 7.5 7.99999V18C7.5 18.1326 7.55268 18.2598 7.64645 18.3535C7.74021 18.4473 7.86739 18.5 8 18.5H16C16.1326 18.5 16.2598 18.4473 16.3536 18.3535C16.4473 18.2598 16.5 18.1326 16.5 18V7.99999C16.5 7.93433 16.4871 7.86931 16.4619 7.80864C16.4368 7.74798 16.4 7.69286 16.3535 7.64644ZM12 7.99999C11.8022 7.99999 11.575 7.91853 11.4105 7.80865C11.2461 7.69877 11.1518 7.5654 11.0761 7.38267C11.0004 7.19995 10.9806 6.99888 11.0192 6.8049C11.0578 6.61092 11.153 6.43274 11.2929 6.29288C11.4327 6.15303 11.6109 6.05779 11.8049 6.01921C11.9989 5.98062 12.2 6.00042 12.3827 6.07611C12.5654 6.1518 12.7216 6.27997 12.8315 6.44442C12.9414 6.60887 13 6.80221 13 6.99999C13 7.26521 12.8946 7.51956 12.7071 7.7071C12.5196 7.89463 12.2652 7.99999 12 7.99999Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 16.5H10C9.86739 16.5 9.74021 16.4473 9.64645 16.3536C9.55268 16.2598 9.5 16.1326 9.5 16C9.5 15.8674 9.55268 15.7402 9.64645 15.6464C9.74021 15.5527 9.86739 15.5 10 15.5H14C14.1326 15.5 14.2598 15.5527 14.3536 15.6464C14.4473 15.7402 14.5 15.8674 14.5 16C14.5 16.1326 14.4473 16.2598 14.3536 16.3536C14.2598 16.4473 14.1326 16.5 14 16.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 14.5H10C9.86739 14.5 9.74021 14.4473 9.64645 14.3536C9.55268 14.2598 9.5 14.1326 9.5 14C9.5 13.8674 9.55268 13.7402 9.64645 13.6464C9.74021 13.5527 9.86739 13.5 10 13.5H14C14.1326 13.5 14.2598 13.5527 14.3536 13.6464C14.4473 13.7402 14.5 13.8674 14.5 14C14.5 14.1326 14.4473 14.2598 14.3536 14.3536C14.2598 14.4473 14.1326 14.5 14 14.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 12.5H10C9.86739 12.5 9.74021 12.4473 9.64645 12.3536C9.55268 12.2598 9.5 12.1326 9.5 12C9.5 11.8674 9.55268 11.7402 9.64645 11.6464C9.74021 11.5527 9.86739 11.5 10 11.5H14C14.1326 11.5 14.2598 11.5527 14.3536 11.6464C14.4473 11.7402 14.5 11.8674 14.5 12C14.5 12.1326 14.4473 12.2598 14.3536 12.3536C14.2598 12.4473 14.1326 12.5 14 12.5Z",
    fill: props.foregroundColor
  }));
};

Tag.defaultProps = {
  altText: "Tag",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Tag.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Tag;
exports.default = _default;